import React, { useEffect, useState } from "react";
import "./Header.css";
import {
  ChantBrandmark,
  ChantBrandmarkTaglineIcon,
} from "../../../utils/icons.jsx";
import useAdminDataStore, {
  selectCurrentGroupData,
  selectAllGroups,
  selectCurrentGroupId,
} from "../../../store/adminData/adminData";
import useUserStore, { selectUserDetails } from "../../../store/user/user";
import { CrownOutlined, MenuOutlined } from "@ant-design/icons";
import { adminGroupChange } from "../../../redux/actions/adminData";
import { NavLink, useLocation } from "react-router-dom";
import DashboardLinks from "./DashboardLinks";
import { Skeleton } from "antd";
import NotificationIcon from "../../commons/NotificationIcon/NotificationIcon";
import AnnouncementHistoryPanel from "../../commons/AnnouncementHistoryPanel/AnnouncementHistoryPanel";
import GroupDropdown from "./GroupDropdown/GroupDropdown.jsx";
import useDashboardInfo from "../../../hooks/useDashboardInfo.js";
import useUserRole from "../../../hooks/useUserRole.jsx";
import useGlobalStore from "../../../store/store.js";

const Header = ({ toggleSideNav, loading = false }) => {
  const ImageColor = { black: 1, white: 2 };

  const allGroups = useAdminDataStore(selectAllGroups);
  const currentGroup = useAdminDataStore(selectCurrentGroupId);
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const user = useUserStore(selectUserDetails);

  let prefferedImageColor = ImageColor.white;

  {
    const group = allGroups[currentGroup];
    const gData = group ? group.data : null;

    if (gData) {
      if (gData.configuration && gData.configuration.primaryColor) {
        let { r, g, b } = gData.configuration.primaryColor;
        if ([r, g, b].filter((e) => `${e}` === "255").length === 3) {
          prefferedImageColor = ImageColor.black;
        }
      }
    }
  }

  const groupNameKeyMap = {};
  const groupIdLogoMap = {};
  Object.entries(allGroups).forEach(([key, group]) => {
    groupNameKeyMap[group?.data?.groupName] = key;
    groupIdLogoMap[key] = (group?.data?.configuration || {}).logo;
  });

  const [clubGroups, setClubGroups] = useState({});
  const [dashboard, setDashboard] = useState("admin");
  const { dashboardType } = useDashboardInfo();
  const { userRole } = useUserRole();

  const location = useLocation();

  const panelVisible = useGlobalStore((state) => state.alerts.panelVisible);
  const setPanelVisible = useGlobalStore(
    (state) => state.alerts.setPanelVisible
  );

  const handleNotificationClick = () => {
    setPanelVisible(true);
  };

  const handlePanelClose = () => {
    setPanelVisible(false);
  };

  useEffect(() => {
    if (user.isAuthenticated && user.role === "admin") {
      const currentGroup = window.localStorage.getItem("currentGroup");
      const dashboard =
        window.localStorage.getItem("dashboardType") ||
        location.pathname.split("/")[1] ||
        "admin";

      const storeCurrentGroup = useAdminDataStore.getState().currentGroup;
      if (currentGroup && currentGroup !== storeCurrentGroup) {
        const storeAllGroups = useAdminDataStore.getState().allGroups;
        const found = Object.keys(storeAllGroups).find(
          (group) => group === currentGroup
        );

        if (found) {
          adminGroupChange({ group: found, dashboardType: dashboard });
        } else if (storeCurrentGroup === "") {
          const gMap = {};
          Object.entries(storeAllGroups).forEach(([key, group]) => {
            gMap[group?.data?.groupName] = key;
          });

          const groupName = Object.keys(gMap).sort((name1, name2) =>
            name1.localeCompare(name2)
          )[0];

          adminGroupChange({
            group: gMap[groupName],
            dashboardType: dashboard,
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user.userRoles) {
      const ids = Object.keys(user?.userRoles).filter(
        (id) => user?.userRoles?.[id] === "parentAdmin"
      );

      if (ids.length > 0) {
        ids.forEach((id) => {
          const dashboardFromPath = location.pathname
            ? location.pathname.split("/")[1] || "admin"
            : "admin";

          setClubGroups((prev) => ({
            ...prev,
            [id]: allGroups?.[id],
          }));
          setDashboard(dashboardFromPath);
        });
      } else {
        setDashboard("admin");
      }
    }
  }, [user.userRoles, allGroups, location.pathname]);

  return (
    <nav
      className="header-navbar"
      style={{
        backgroundColor: loading ? "var(--loading-state-color)" : undefined,
        borderBottomColor: loading ? "var(--loading-state-color)" : undefined,
      }}
    >
      <div className="header-container">
        {/* Logo */}
        {user.isAuthenticated && window?.innerWidth <= 768 ? (
          <MenuOutlined
            onClick={toggleSideNav}
            style={{
              cursor: "pointer",
              fontSize: "24px",
              color: "var(--primary-text-color)",
            }}
          />
        ) : (
          <img
            style={{
              padding: "0",
              margin: "0",
              width: "100px",
            }}
            alt="company-logo"
            src={
              prefferedImageColor === ImageColor.white
                ? ChantBrandmark
                : ChantBrandmarkTaglineIcon
            }
          />
        )}

        <div>
          <ul
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              margin: 0,
              color: "var(--primary-text-color)",
              gap: "14px",
              listStyleType: "none",
              fontSize: "0.9rem",
              ...(window.innerWidth < 1280 && { display: "none" }),
            }}
          >
            {/* dashboard links*/}
            {!user.isAuthenticated && <DashboardLinks />}

            {/* Members links */}
            {user.isAuthenticated && user.role === "member" && (
              <>
                <li
                  className="nav-item"
                  data-toggle="collapse"
                  data-target=".navbar-collapse.show"
                >
                  <NavLink to="/membership" className="nav-link">
                    Membership
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </div>

        {/* {import.meta.env.VITE_NODE_ENV === "development" && (
          <div
            onClick={() => {
              copyToClipboard(groupData?.id);
            }}
            style={{
              cursor: "pointer",
              backgroundColor: "white",
              color: "black",
              padding: "10px",
              borderRadius: "5px",
              margin: "10px",
            }}
          >
            <p>{groupData?.id}</p>
          </div>
        )} */}

        {/* Group Selector */}
        {user.isAuthenticated &&
        user.role === "admin" &&
        ["admin", "clubadmin"].includes(dashboard) &&
        ["admin", "parentAdmin"].includes(
          user.userRoles[currentGroup]
        ) ? (
          <>
            <div className="group-selector">
              <NotificationIcon onClick={handleNotificationClick} />
              {loading ? (
                <Skeleton.Avatar
                  active
                  size="default"
                  shape="circle"
                  style={{ width: 32, height: 32 }}
                />
              ) : (
                Object.keys(groupNameKeyMap).length > 1 &&
                groupIdLogoMap[currentGroup] && (
                  <img
                    src={groupIdLogoMap?.[groupData?.id]}
                    alt="group-logo"
                    className={`chant-header-image${groupData?.configuration?.isLogoTransparent ? "--transparent" : ""}`}
                  />
                )
              )}

              <div>
                <GroupDropdown
                  dashboard={dashboard}
                  clubGroups={clubGroups}
                  groupNameKeyMap={groupNameKeyMap}
                  setDashboard={setDashboard}
                />
              </div>
            </div>
            <AnnouncementHistoryPanel
              visible={panelVisible}
              onClose={handlePanelClose}
            />
          </>
        ) : userRole === "superadmin" && dashboardType === "superadmin" ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <div className="flex-center">
              <CrownOutlined
                style={{
                  fontSize: 28,
                  color: "var(--primary-text-color)",
                }}
                aria-label="super-admin"
              />
            </div>

            <div className="flex-center">
              <h5 style={{ color: "var(--primary-text-color)", margin: 0 }}>
                Super-Admin
              </h5>
            </div>
          </div>
        ) : null}
      </div>
    </nav>
  );
};

export default Header;
